import type { LearningStatus } from '@mathflat/domain/Worksheet'

export const examLearningContentStatusText: Record<LearningStatus, string> = {
  INCOMPLETE: '미응시',
  PROGRESS: '응시중',
  COMPLETE: '제출완료',
  EXPIRED: '제출완료',
}
